<!-- eslint-disable -->
<template lang="pug">
    form.fields(action="javascript://", @submit="sendForm")
        .fields__element(v-if="user.type !== 'student' && user.pointsAccesses.length > 1 && !pointsHistoryTypes.includes($route.params.type)")
            label.fields__label {{ $i18n.t('fields.fields_pointsFor') }}
            cs-multiselect.fields__input(
                v-if="user.pointsAccesses.length > 1"
                :multiple="false",
                :options="pointsAccesses",
                :show-labels="false",
                label="label",
                track-by="mode",
                :allow-empty="false",
                :searchable="false",
                :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                @select="selectPointsAccess($event.mode)"
                v-model="selectedPointsAccess"
            )
        .fields__element(v-if="user.isSuperadmin || user.type !== 'student'")
            .fields__label {{ $i18n.tc('fields.fields_school', 0) }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="schools",
                :show-labels="false",
                label="name",
                track-by="id",
                :searchable="true",
                :loading="loadingSchools",
                @open="getSchools",
                :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                v-model="form.school"
            )
                span(slot="noResult") {{ $i18n.t('fields.fields_schoolNotFound') }}
        .fields__element(v-if="user.type !== 'student' && user.type !== 'olympiads-student'")
            .fields__label {{ $i18n.tc('fields.fields_grade', 0) }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="grades",
                :show-labels="false",
                label="name",
                track-by="id",
                :loading="loadingGrades",
                :placeholder="gradesPlaceholder",
                v-model="form.grade",
                :disabled="isGradeDisabled",
                @open="getGrades"
            )
                span(slot="noResult") {{ $i18n.t('fields.fields_gradeNotFound') }}
        .fields__element(v-if="user.type !== 'student' && user.type !== 'olympiads-student'")
            .fields__label {{ $i18n.t('fields.fields_status') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="statuses",
                :show-labels="false",
                :allow-empty="false",
                :custom-label="getStatusName",
                placeholder="",
                v-model="form.status",
                :searchable="false"
            )
        .fields__element(v-if="user.type !== 'student'")
            label.fields__label {{ $i18n.t('fields.fields_search') }}
            cs-search-input.fields__input(
                :placeholder="$i18n.t('fields.list_studentPlaceholder')",
                v-model="form.fullName"
                @search="sendForm"
            )
        .fields__element_date
            .fields__element--period
                .fields__label(:class="{'fields__label-period': user.type === 'student' || user.type === 'olympiad-student'}")
                    | {{ $i18n.t('fields.fields_period') }}
                cs-datepicker.datepicker-input-container--no-margin(
                    :language="user.locale",
                    :disabled-dates="form.dateTo ? {from: new Date(form.dateTo)} : {}",
                    :format="customFormatter",
                    v-model="form.dateFrom"
                )
                .fields__divider —
                cs-datepicker.datepicker-input-container--no-margin(
                    :language="user.locale",
                    :disabled-dates="form.dateFrom ? {to: new Date(form.dateFrom)} : {}",
                    :format="customFormatter",
                    v-model="form.dateTo"
                )
                .fields__period-buttons-container
                    a.fields__period-button(href="javascript://", @click="setPeriod('day')")
                        | {{ $i18n.t('fields.fields_dayPeriod') }}
                    a.fields__period-button(href="javascript://", @click="setPeriod('week')")
                        | {{ $i18n.t('fields.fields_weekPeriod') }}
                    a.fields__period-button(href="javascript://", @click="setPeriod('month')")
                        | {{ $i18n.t('fields.fields_monthPeriod') }}
</template>

<script>
    /*eslint-disable*/
    import SchoolApi from '../../../api/school';
    import GradeApi from '../../../api/grade';
    import UserApi from '../../../api/user/user';
    import searchFieldsMixin from '../../../utils/searchFieldsMixin';
    import {mapState} from 'vuex';
    import _ from 'lodash';
    import searchParamsStore from '../utils/searchParamsStore';
    import statusFieldMixin from '../utils/statusFieldMixin';
    import moment from 'moment';

    export default {
        mixins: [searchFieldsMixin, searchParamsStore, statusFieldMixin],
        props: ['schoolId', 'gradeId', 'userId'],
        mounted () {
            if (this.user.type !== 'student' && this.$route.params.pointsAccess) {
                this.form.pointsAccess = this.$route.params.pointsAccess;
            } else if (this.user.type !== 'student' && !this.form.pointsAccess) {
                this.form.pointsAccess = this.user.pointsAccesses[0] || '';
            } else {
                this.form.pointsAccess = this.selectedCourse;
            }
            this.selectedPointsAccess = this.pointsAccesses.find(access => access.mode === this.form.pointsAccess);
        },
        data () {
            return {
                accessInitialized: false,
                schools: [],
                grades: [],
                form: {
                    school: null,
                    grade: null,
                    fullName: null,
                    dateFrom: null,
                    dateTo: null,
                    status: 'active',
                    pointsAccess: '',
                },
                allPointsAccesses: [
                    {
                        label: this.$i18n.t('common.common_points_forMentalArithmetic'),
                        mode: 'mentalArithmetic'
                    },
                    {
                        label: this.$i18n.t('common.common_points_forFastReading'),
                        mode: 'fastReading'
                    },
                    {
                        label: this.$i18n.t('common.common_points_forOnlineSchool'),
                        mode: 'onlineSchool'
                    },
                    {
                        label: this.$i18n.t('common.common_points_forMathMagic'),
                        mode: 'mathMagic'
                    },
                    {
                        label: this.$i18n.t('common.common_points_forMemoryDevelopment'),
                        mode: 'memoryDevelopment'
                    },
                    {
                        label: this.$i18n.t('common.common_points_forMultiplication'),
                        mode: 'multiplication'
                    },
                    {
                        label: this.$i18n.t('common.common_points_forReadingEn'),
                        mode: 'readingEn'
                    },
                    {
                        label: this.$i18n.t('common.common_points_forRussianLanguage'),
                        mode: 'russianLanguage'
                    }
                ],
                selectedPointsAccess: null,
                pointsHistoryTypes: ['miles', 'detective', 'battle'],
            }
        },
        watch: {
            '$route.query' (val) {
                if (_.isEmpty(val)) {
                    this.form = _.cloneDeep(this.localSearchParams) || {
                        school: null,
                        fullName: null,
                        grade: null,
                        dateFrom: null,
                        dateTo: null,
                        status: 'active',
                        pointsAccess: this.user.pointsAccesses[0] || '',
                    };
                }
            },
            'form.status' () {
                this.updateList()
            },
            'form.pointsAccess'() {
                if (this.accessInitialized) {
                    this.updateList()
                } else {
                    this.accessInitialized = true
                }
            },
            'form.dateFrom'() {
                this.updateList()
            },
            'form.dateTo'() {
                this.updateList()
            },
            'form.school'() {
                this.updateList()
            },
            'form.grade'() {
                this.updateList()
            },
            'form.fullName'() {
                this.updateList()
            },
            selectedCourse(newVal, oldVal) {
                if (newVal !== oldVal && oldVal) {
                    this.selectPointsAccess(newVal);
                }
            }
        },
        methods: {
            sendForm() {
                if (this.form.dateFrom) {
                    this.form.dateFrom = moment(this.form.dateFrom).format('YYYY-MM-DD');
                }
                if (this.form.dateTo) {
                    this.form.dateTo = moment(this.form.dateTo).format('YYYY-MM-DD');
                }
                this.$emit('search', this.form);
            },
            setPeriod(range) {
                this.form.dateFrom = moment().startOf(range).format();
                this.form.dateTo = moment().endOf(range).format();
            },
            resetResults() {
                this.user.isSuperadmin && (this.form.school = null);
                this.form.grade = null;
                this.form.fullName = null;
                this.form.dateFrom = null;
                this.form.dateTo = null;
                this.form.status = 'active';
                this.form.pointsAccess = this.user.type !== 'student' ? this.pointsAccesses[0].mode : this.selectedCourse;
                this.selectedPointsAccess = this.pointsAccesses.find(access => access.mode === this.form.pointsAccess);
                if (this.user.pointsAccesses.length > 1) {
                    this.$route.params.pointsAccess = this.pointsAccesses[0].mode;
                }
                this.$emit('search', this.form);
            },
            selectPointsAccess (mode) {
                this.form.pointsAccess = mode;
                this.$route.params.pointsAccess = mode;
            },
            customFormatter(date) {
                return moment(date).format('D MMM YYYY');
            },
            updateList: _.debounce(function() {
                this.sendForm()
            }, 1000)
        },
        computed: {
            ...mapState({
                selectedCourse: state => state.trainer.course,
                user: state => state.auth.user,
            }),
            pointsAccesses () {
                return this.allPointsAccesses.filter(access => this.user.pointsAccesses.includes(access.mode));
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../assets/sass/fields/fields.scss";
</style>
